module.exports = __webpack_public_path__ + "img/car.02c28acb.png";